import store from "app/redux/store";

const richTextHelpers = {
  getIndentation(text) {
    let indentation = 0;
    let tabs = text.match(/(^\t+)/);
    if (tabs) {
      indentation = tabs[0].length;
    } else {
      let spaceTabs = text.match(/(^  )(  )*/);
      if (spaceTabs) {
        indentation = spaceTabs[0].length / 2;
      }
    }
    return indentation;
  },
  // bulletRegex: new RegExp(
  //   /(^\t* *)[\-\u2013\–\u2014\*\u002A\•\u2022\◦\u25E6\●\u25cf\○\u25cb\■\u25a0\□\u25a1] /,
  //   "im",
  // ),
  bulletRegex: new RegExp(
    /^(?:\t* *)[\-\u2013\u2014\u002A\u2022\u25E6\u25cf\u25cb\u25a0\u25a1] /,
    "im",
  ),
  // numbered list marker: "1. " or "1) " (groups: indent, number, delimiter)
  numberedRegex: /^(\t* *)(\d+)([.)]) /,
  getBullet(text, indentation = null) {
    let bullet = null;
    let bulletMatch = text.match(richTextHelpers.bulletRegex);
    if (!!bulletMatch) {
      // bullet = bulletMatch[0].trim();
      indentation =
        typeof indentation == "number"
          ? indentation
          : richTextHelpers.getIndentation(text);
      let bulletString = bulletMatch[0];
      let bullets = ["●", "○", "■", "□"];
      let newText = new Array(indentation).fill("\t").join("");
      let bulletIndex = indentation % bullets.length;
      bullet = bullets[bulletIndex];
    }
    return bullet;
  },
  getLineObject(text) {
    let indentation = richTextHelpers.getIndentation(text);
    let bullet = null;
    let body = text.trim();
    let bulletMatch = text.match(richTextHelpers.bulletRegex);
    if (!!bulletMatch) {
      let bulletString = bulletMatch[0];
      let re = new RegExp(`${bulletString}(.*)`);
      body = text.split(re)[1] || "";
      let bullets = ["●", "○", "■", "□"];
      let bulletIndex = indentation % bullets.length;
      bullet = bullets[bulletIndex];
    }
    // let body = text
    return { indentation, bullet, body };
  },
  findStartingIndex(text) {
    let index = 0;

    // indentation
    let indentation = richTextHelpers.getIndentation(text);
    index = indentation;

    // bullets
    if (!!text.match(richTextHelpers.bulletRegex)) {
      index += 2;
    }

    // headers
    let header = text.match(/(^\t* *)(#+ )/);
    if (header) {
      index = header[0].length;
    }

    return index;
  },
  formatBulletLine(text) {
    // let bulletMatch = text.match(
    //   /(^\t* *)[\-\u2013\–\u2014\*\u002A\•\u2022\◦\u25E6\●\u25cf\○\u25cb\■\u25a0\□\u25a1] /
    // );
    let bulletMatch = text.match(richTextHelpers.bulletRegex);
    /*
      small
      • \u2022
      ◦ \u25E6
      medium
      ● \u25cf
      ○ \u25cb
      ■ \u25a0
      □ \u25a1
      */
    if (!!bulletMatch) {
      let indentation = richTextHelpers.getIndentation(text);
      let bulletString = bulletMatch[0];
      let bullets = ["●", "○", "■", "□"];
      let newText = new Array(indentation).fill("\t").join("");
      let bulletIndex = indentation % bullets.length;
      newText += bullets[bulletIndex] + " ";
      newText += text.split(bulletString)[1] || "";
      text = newText;
    }
    return text;
  },
  injectReferences(string = "", values = []) {
    let res = "";
    string.split(/{([^}]+)}/).forEach((txt, i) => {
      if (!(i % 2)) {
        if (txt.length) {
          res += txt;
        }
      } else {
        let id = parseInt(txt.split(/[|-]/)[0]);
        let value = values.find((v) => v.id == id);
        if (!value) {
          // callers pass partial reference sets — fall back to the store
          value = store.getState().values.find((v) => v.id == id);
        }
        if (!!value) {
          if (txt.includes("|")) {
            txt = txt.split("|")[1] || value.title || value.text;
          } else {
            txt = value.title || value.text;
          }
        } else txt = "–";
        res += txt;
      }
    });
    return res;
  },
  getReferences(string = "", allValues = [], returnObjects = false) {
    let ids = [];
    let values = [];

    if (string.split(/{([^}]+)}/).length >= 3) {
      string.split(/{([^}]+)}/).forEach((txt, i) => {
        if (!!(i % 2)) {
          let id = parseInt(txt.split(/[|-]/)[0]);
          if (id) ids.push(id);
          if (returnObjects) {
            let value = allValues.find((v) => v.id == id);
            if (value) values.push(value);
          }
        }
      });
    }
    if (returnObjects) return values;
    return ids;
  },
  adjustIndexForPlainText(caretPos, text) {
    // let cleanText = richTextHelpers.filterRichText(text);
    // let lengthChange = text.length - cleanText.length;
    // console.error(lengthChange, text, cleanText);
    // caretPos += lengthChange / 2;

    // this is quite tricky... need to account for references too
    // also, when a richtext span is clicked, caretPos comes from the anchorOffset of that span, no the whole line

    return caretPos;
  },
  filterRichText(
    text = "",
    value = {},
    options = {},
    values = [],
    log = false,
  ) {
    if (!text) text = "";
    let { removeLinebreaks = true } = options;
    // remove headers
    text = text.replace(/#{1,3} .*[\r\n]*/g, (match) =>
      match.replace(/#{1,3} /, ""),
    );
    // remove decorations
    text = text.replace(/_*/g, "");
    text = text.replace(/~*/g, "");
    text = text.replace(/`*/g, "");
    // remove linebreaks
    if (removeLinebreaks) {
      text = text.replace(/[\r\n]/g, " ");
    }
    text = text.trim();
    // replace refs
    text = text.replace(/{([^}]+)}/g, (tag) => {
      let res = tag;
      tag = tag.slice(1, -1);
      let txt = tag.split(`|`)[1];
      if (!!txt?.length) {
        res = txt;
      } else {
        let id = tag.split(`|`)[0];
        let ref;
        let searchValues = [...(value?.references || []), ...values, value];
        if (id == "parent" && !!value?.parent_ids) {
          id = value?.parent_ids[0];
        }
        id = parseInt(id);
        ref = searchValues.find((r) => r.id == id);
        if (!ref) ref = store.getState().values.find((v) => v.id == id);
        if (ref) res = ref.title || ref.text;
        else res = `#${id}`;
      }
      return `[${res}]`;
    });
    return text;
  },
};

export default richTextHelpers;
